/**
 * Core SFRA function for run everything everywhere
 * @param {Function || Object} include - stuff to run
 */
const processInclude = include => {
    if (typeof include === 'function') {
        include();
    } else if (typeof include === 'object') {
        Object.keys(include).forEach(function (key) {
            if (typeof include[key] === 'function') {
                include[key]();
            }
        });
    }
};

// Enqueues tasks to be executed afterwards
function enqueueTask (task) {
    window.requestAnimationFrame(task);
}

function preventDefault(e) {
    e.preventDefault();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
const parseHtml = (html, map) => {
    const el = document.createElement('div');
    el.innerHTML = html;

    let htmlMap = {};
    for (var key in map) {
        if (map.hasOwnProperty(key)) {
            htmlMap[key] = el.querySelector(map[key]);
        }
    }

    return htmlMap;
};

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
const appendToUrl = (url, params) => {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
};

function isIOSMobile () {
    const ua = navigator.userAgent;

    // Detect iPhone, iPad, iPod
    if (/iPad|iPhone|iPod/.test(ua)) {
        return true;
    }

    // Detect iPadOS 13+ which reports as Mac
    if (/Macintosh/.test(ua) && 'ontouchend' in document) {
        return true;
    }

    return false;
}

const lockScroll = () => {
    $('body, html').css('overflow-y', 'hidden');
    if (isIOSMobile()) {
        $('body, html').css('position', 'fixed');
    }
};

const unlockScroll = () => {
    $('body, html').css('overflow-y', '');
    if (isIOSMobile()) {
        $('body, html').css('position', '');
    }
};

const cookieExists = (name) => {
    return document.cookie.split(';').filter((item) => {
        return item.trim().indexOf(`${name}=`) === 0;
    }).length;
};

const createCookie = (name, value = false, days = 0) => {
    var expires;
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toGMTString();
    } else {
        expires = '';
    }
    document.cookie = name + '=' + value + expires + '; path=/';
};

export {
    appendToUrl,
    cookieExists,
    createCookie,
    enqueueTask,
    processInclude,
    parseHtml,
    lockScroll,
    unlockScroll,
    preventDefault
};
